<cdk-virtual-scroll-viewport
  #scrollViewport
  [itemSize]="53"
  id="dataTable"
  [ngClass]="{
    'virtual-scroll-heigth': cart && cart.length > 0,
    'virtual-scroll-auto': !cart || !cart.length
  }"
>
  <table class="table-wvs">
    <thead>
      <tr class="title">
        <ng-container
          *ngIf="(selectedAll || partiallySelected) && cart.length > 0"
        >
          <ng-container *ngFor="let action of actionHeader">
            <th
              [style.top]="inverseOfTranslation"
              class="headers header-checbox-checked"
              [attr.colspan]="displayedColumns.length"
            >
              <div class="header-content">
                    <mat-checkbox
                      [checked]="selectedAll"
                      [indeterminate]="partiallySelected"
                      (change)="selectionOfAllCheckbox($event)"
                    ></mat-checkbox>
                    <button
                      mat-icon-button
                      *ngFor="let icons of action.action; let i = index"
                      [id]="i + 'header-icon-' + icons.icon"
                      [hidden]="hasHiddenIconHeader(icons)"
                      (click)="onClickIconHeader(icons.icon, i)"
                    >
                      <mat-icon
                        class="icon-table"
                        [svgIcon]="icons.icon"
                        [matTooltip]="icons.tooltip"
                      ></mat-icon>
                    </button>
              </div>
            </th>
          </ng-container>
        </ng-container>

        <ng-container
          *ngIf="(!selectedAll && !partiallySelected) || cart.length === 0"
        >
          <th
            [style.top]="inverseOfTranslation"
            class="headers"
          >
            <mat-checkbox
              [checked]="selectedAll"
              [indeterminate]="partiallySelected"
              (change)="selectionOfAllCheckbox($event)"
            ></mat-checkbox>
          </th>
          <th
            [style.top]="inverseOfTranslation"
            class="headers"
            *ngFor="let item of displayedColumns; let i = index"
            [ngClass]="item.class"
          >
            <div [ngClass]="{ 'header-icon-menu': item.icons }">
              <span>{{ item.title }}</span>
            </div>
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr
        *cdkVirtualFor="
          let element of dataSource;
          let i = index;
          trackBy: trackById
        "
        class="rows"
      >
        <td>
          <mat-checkbox
            [formControl]="$any(checkboxRows.at(i))"
            (change)="
              validateSelectedRows($event, element); changeSelectCheckbox()
            "
          ></mat-checkbox>
        </td>
        <td
          *ngFor="let item of displayedColumns; let i = index"
          [ngClass]="item.class"
        >
          <span>
            {{ item.value(element) }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>

</cdk-virtual-scroll-viewport>
